import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { ColorScheme } from '../extensions/colorscheme';
import { environment } from 'src/_environments/environment';
import { GlobalService } from 'src/_service/GlobalService';

@Component({
  selector: 'app-base-personselector',
  template: `
    <p>
      base personselector works!
    </p>
  `,
  styles: [],
})
export class BasePersonselectionComponent extends ColorScheme {

private _globalService = inject(GlobalService)


  @Input() minpersons: number = this._globalService.minSubscriptionPersons;
  @Input() maxpersons: number = this._globalService.maxSubscriptionPersons;
  private _personsoptions: number[] = environment.subscriptionPersonChoices;
  @Input() set personsoptions(value: number[]) {
    this._personsoptions = value;
    if (!value) return
    this.minpersons = Math.min(...value)
    this.maxpersons = Math.max(...value)
  }
  get personsoptions() {
    return this._personsoptions
  }

  @Input() doublepersons = false;
  _persons: number = environment.personCountDefault
  @Input() set persons(value: number) {
    if (!value) return;
    value = Number(value);
    if (this.personsoptions && this.personsoptions.includes(value)) {
      this._persons = value;
      return;
    }
    if (environment.subscriptionPersonChoices.includes(value))
      this._persons = value;
  }
  _small = false;
  @Input() set small(value: boolean | string) {
    if (value || value === '')
      this._small = true
  }
  @Input() editable = true;
  @Input() boldNumber = true;

  @Output() personsChange: EventEmitter<number> = new EventEmitter<number>()

  
  constructor(
  ) {
    super()
  }

  changePersonQty(qty: number) {
    let personsindex = this.personsoptions.indexOf(this._persons);
    if (personsindex + qty <= this.personsoptions.length - 1 && personsindex + qty >= 0)
      this._persons = this.personsoptions[personsindex + qty]

    this.personsChange.emit(this._persons)
  }


}
